import { FETCH_ALL_SCOPES } from "./ActionTypes";
import { Api, Scope } from "./PropTypes";

const initialState: Api = <Api>{};

export default function apiReducer(state = initialState, action: any) {
    const { payload }  = action;
    switch (action.type) {
        case FETCH_ALL_SCOPES.SUCCESS: {
            const allScopes = payload.data;
            
            return {
                ...state,
                scopes: allScopes
            };
        }
        case FETCH_ALL_SCOPES.FAILURE:
            return state;

        default:
            return state;
    }
}